export default {
  public_layout: {
    login: 'Login',
    cookies: {
      title: 'Cookies preferences',
      text: 'SorareMega uses cookies to collect data helping us to provide you with the best user experience',
      learn_more: 'To learn more, check our',
      privacy_policy: 'Privacy Policy',
      accept: 'Accept',
      decline: 'Decline',
    },
  },
  home: {
    enter_the_arena: 'Enter the Arena',
    leagues_score_dice_cups: 'Leagues • Score Dice • Cups',
    start_playing_now: 'Start playing now',
  },
  login: {
    login_with_sorare: 'Log in with your Sorare account',
    dont_have_sorare_account: 'Don\'t have a Sorare account?',
    create_one_now: 'Create one now',
  },
  coming_soon: {
    soraremega_will_come_back_soon: 'SorareMega is coming back soon',
    enter_email: 'Enter your email to stay informed and receive the latest news',
    submit: 'Submit',
    success_message: 'Thank you for your registration',
  },
  nav: {
    help: 'Help',
    logout: 'log out',
  },
  manager_profile: {
    gallery: 'GALLERY',
  },
  mega_league_result: {
    my_fixture: 'My fixture',
    leaderboard: 'Leaderboard',
    fixtures: 'Fixtures',
    no_fixture_for_this_gw: 'No fixture',
  },
  beta_tester: {
    only_for_beta_tester: 'Only for beta tester',
  },
  game_week: {
    ended: 'ENDED',
    waiting: 'WAITING',
    live: 'LIVE',
    open: 'OPEN',
  },
  lobby: {
    play: 'Play',
    edit: 'Edit',
    live_results: 'Live results',
    results: 'Results',
  },
  filter_menu: {
    filter: 'Filter',
    playing_this_gw: 'Playing this GW',
    show_last_5_score: 'Show last 5 scores',
  },
  filter_drawer: {
    sort_by: 'Sort by',
    scarcity: 'Scarcity',
    position: 'Position',
    last_recruits: 'Last recruits',
    name: 'Name',
    unique: 'Unique',
    super_rare: 'Super-rare',
    rare: 'Rare',
    limited: 'Limited',
    forward: 'Forward',
    midfielder: 'Midfielder',
    defender: 'Defender',
    goalkeeper: 'Goalkeeper',
  },
  formation: {
    formation: 'Formation',
  },
  status: {
    confirmed: 'Confirmed',
    not_confirmed: 'Not confirmed',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  card_picker: {
    no_card_picked: 'No card picked',
  },
  pick_card_dialog: {
    player_pick: 'Player pick',
  },
  first_login_dialog: {
    settings : 'Settings',
    email_address : 'Email address',
    save : 'Save',
    invalid_email : 'Invalid email',
  },
  user_lineup_dialog:{
    unable_to_load_lineup: 'Unable to load team',
  },
  lineup_header:{
    average_per_free_position: 'Average per free position :',
  },
  stats: {
    yellow_card: 'Yellow card',
    foul: 'Foul',
    was_fouled: 'Was fouled',
    error_lead_to_shot: 'Error lead to shot',
    clean_sheet: 'Clean sheet',
    goal_conceded: 'Goal conceded',
    effective_clearance: 'Effective clearance',
    won_tackle: 'Won tackle',
    blocked_cross: 'Blocked cross',
    outfielder_block: 'Outfielder block',
    possession_lost: 'Possession lost',
    possession_won: 'Possession won',
    duel_lost: 'Duel lost',
    duel_won: 'Duel won',
    interception_won: 'Interception won',
    big_chance_created: 'Big chance created',
    attempted_assist: 'Attempted assist',
    accurate_pass: 'Accurate pass',
    accurate_final_third_pass: 'Accurate final third pass',
    accurate_long_ball: 'Accurate long ball',
    accurate_own_to_opposite_pass: 'Long pass into opposition',
    missed_pass: 'Missed pass',
    shot_on_target: 'Shot on target',
    won_contest: 'Won contest',
    penalty_area_entry: 'Penalty area entry',
    penalty_kick_missed: 'Penalty kick missed',
    big_chance_missed: 'Big chance missed',
    save: 'Save',
    saved_shot_from_inside_box: 'Saved shot from inside box',
    good_high_claim: 'Good high claim',
    punch: 'Punch',
    dive_save: 'Dive save',
    dive_catch: 'Dive catch',
    cross_not_claimed: 'Cross not claimed',
    six_second_violation: 'Six second violation',
    gk_smother: 'Goalkeeper smother',
    keeper_sweeper: 'Keeper sweeper',
  },
  splitted_score: {
    decisive: 'Decisive',
    all_around: 'All around',
  },
  snackbar: {
    team_successfully_confirmed: 'Team successfully confirmed',
    duplicated_card: 'Duplicated card',
    duplicated_player: 'Duplicated player',
    invalid_captain: 'Invalid captain',
    missing_captain: 'Missing captain',
    invalid_formation: 'Invalid formation',
    invalid_ownership: 'Invalid ownership',
    invalid_position: 'Invalid position',
    invalid_scarcity: 'Invalid scarcity',
    invalid_edition: 'Invalid edition',
    goalkeeper_required: 'Goalkeeper required',
    invalid_goalkeeper: 'Invalid goalkeeper',
    invalid_defenders: 'Invalid defenders',
    invalid_midfielders: 'Invalid midfielders',
    invalid_forwards: 'Invalid forwards',
    team_canceled: 'Team canceled',
    cap_exceeded: 'Cap exceeded',
    max_players_per_team: 'Too many players on the same team, maximum 3 allowed'
  },
  mega_league: {
    tabs: {
      my_team: 'My team',
      leaderboard: 'Leaderboard',
    }
  }
};
